import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
  HostListener,
  ElementRef,
  OnInit,
} from '@angular/core';
import * as moment from 'moment';
import { DropdownAnimation } from '../select/dropdown.animation';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  animations: [DropdownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatePickerComponent implements OnInit {
  isOpened: boolean = false;
  isOpenedMonths: boolean = false;
  isOpenedYears: boolean = false;
  weekdays: string[] = [
    'CAL_DAYS_MON',
    'CAL_DAYS_TUE',
    'CAL_DAYS_WED',
    'CAL_DAYS_THU',
    'CAL_DAYS_FRI',
    'CAL_DAYS_SAT',
    'CAL_DAYS_SUN'
  ];
  months: string[] = [
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_JAN', // январь
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_FEB', // февраль
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_MARCH', // март
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_FEB_APR', // апрель
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_MAY', // май
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_JUN', // июнь
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_JUL', // июль
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_AUG', // август
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_SEP', // сентябрь
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_OCT', // октябрь
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_NOV', // ноябрь
    'SALES_EXTENDED_MODEL_VALUE_SEASON_TABLE_DEC', // декабрь
  ];
  years: number[] = [];
  days: moment.Moment[] = [];
  private _selectedDay: moment.Moment = moment();

  @Input()
  get selectedDay(): moment.Moment | string | undefined {
    return this._selectedDay;
  }

  set selectedDay(value: moment.Moment | Date | string | undefined) {
    this._selectedDay = moment(value);
  }

  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _elementRef: ElementRef) {}

  ngOnInit() {
    const currentYear: number = moment().year();
    let startYear: number = currentYear - 10;
    const endYear: number = currentYear + 100;

    do {
      this.years.push(startYear);
      startYear++;
    } while (startYear !== endYear + 1);
  }

  toggle() {
    this.isOpened = !this.isOpened;

    if (this.isOpened) {
      this.renderDays();
    }
  }

  isSelectedDay(day: moment.Moment): boolean {
    if (!this.selectedDay) return false;
    return (this.selectedDay as moment.Moment).isSame(day, 'day');
  }

  openMonths() {
    this.isOpenedMonths = !this.isOpenedMonths;

    if (this.isOpenedMonths) {
      this.scrollToElement('months', `month-${this._selectedDay.month()}`);
    }
  }

  openYears() {
    this.isOpenedYears = !this.isOpenedYears;

    if (this.isOpenedYears) {
      this.scrollToElement('years', `year-${this._selectedDay.year()}`);
    }
  }

  scrollToElement(scrollId: string, elementId: string) {
    setTimeout(() => {
      const myElement = document.getElementById(elementId);
      const topPos = myElement!.offsetTop;

      document.getElementById(scrollId)!.scrollTop = topPos - 30 * 4;
    });
  }

  isSelectedMonth(day: moment.Moment): boolean {
    return this._selectedDay.isSame(day, 'month');
  }

  getMonth(): string {
    return this.months[(this.selectedDay as moment.Moment).month()];
  }

  getYear(): number {
    return (this.selectedDay as moment.Moment)!.year();
  }

  selectMonth(month: string) {
    const monthNumber: number = this.months.indexOf(month);

    this._selectedDay?.set('month', monthNumber);
    this.selectDay(this._selectedDay!.set('month', monthNumber), true);
    this.renderDays();
    this.isOpenedMonths = false;
  }

  selectYear(year: number) {
    this._selectedDay?.set('year', year);
    this.selectDay(this._selectedDay!.set('year', year), true);
    this.renderDays();
    this.isOpenedYears = false;
  }

  selectDay(day: moment.Moment, isOpened: boolean = false) {
    this.selectedDay = day;
    this.isOpened = isOpened;
    this.onChange.emit(this.selectedDay.format('YYYY-MM-DD'));
  }

  renderDays() {
    const startDay = this._selectedDay.clone().startOf('month').startOf('week');
    const endDay = this._selectedDay.clone().endOf('month').endOf('week');
    const day = startDay.clone();

    this.days = [];
    do {
      this.days.push(day.clone());
      day.add(1, 'day');
    } while (!day.isAfter(endDay));
  }

  @HostListener('document:click', ['$event.target'])
  outsideClick(targetElement: Node | null): void {
    if (this.isOpened && !this._elementRef.nativeElement.contains(targetElement)) {
      this.isOpened = false;
      this.isOpenedMonths = false;
      this.isOpenedYears = false;
    }
  }
}
